module.exports = __webpack_public_path__ + "img/notifications/firefox-notifications-blocked-1f59e1e571425e2fccfff4d15605e722.png";